/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { fixAssetBatchDataError, updateAssetsBatchData } from '@/services/asset-batches'
import { useAuth0 } from '@auth0/auth0-react'
import { fields, getDataFields } from './handlers'
import { useState } from 'react'

export const useDataAssetForms = ({
  batchId,
  data,
  dataId,
  isEdit,
  reloadBatch,
  setStage
}) => {
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const [hasAlert, setHasAlert] = useState(false)
  const setFormValues = (data) => {
    if (!data) return null

    let currentData = {}

    if (Array.isArray(data)) {
      if (data.length !== 14) {
        return null
      }

      const dataForm = [data[1], ...data.slice(3)]

      fields.forEach((field, index) => {
        currentData[field.id] = dataForm[index]
      })
    } else {
      currentData = getDataFields(data)
    }

    return currentData
  }
  const onSubmit = async (formData) => {
    try {
      const requiredData = {}
      const currentAction = isEdit
        ? updateAssetsBatchData
        : fixAssetBatchDataError

      requiredData.fileType = formData?.fileType || data.fileType
      requiredData.filename = formData?.filename || data.filename

      if (data.errors) {
        requiredData.fileType = formData.fileType
        requiredData.description = ''
        requiredData.assetStorageId = ''
        requiredData.authorizedAgent = ''
        requiredData.resourceHash = ''
        requiredData.uniqueIdentifier = ''
        requiredData.dataSize = 0
        requiredData.assetsBatchId = +batchId
      }

      const currentData = {
        ...formData,
        ...requiredData,
        creatorUsageRoyalty: `${formData.creatorUsageRoyalty}`,
        publisherUsageRoyalty: `${formData.publisherUsageRoyalty}`
      }
      const response = await currentAction(
        {
          dataId,
          data: currentData
        },
        getAccessToken
      )

      if (response.id) {
        setStage('success')
        reloadBatch && reloadBatch()
      } else {
        setStage('error')
      }
    } catch (error) {
      setHasAlert(true)
    }
  }

  return {
    onSubmit,
    setFormValues,
    hasAlert
  }
}
